import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#FF5537",
            d: "M17.5 3.333c.46 0 .833.373.833.834v11.666c0 .46-.373.834-.833.834h-15c-.46 0-.833-.373-.833-.834V4.167c0-.46.373-.834.833-.834h15zm-.417 4.21l-6.824 3.11c-.137.062-.291.072-.434.03l-.084-.03-6.824-3.11v7.874h14.166V7.543zm0-2.96H2.917V6.17L10 9.397l7.083-3.228V4.583z",
            transform: "translate(-656 -88) translate(656 88)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }